
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[athleteSlug]/memorabilia",
      function () {
        return require("private-next-pages/[athleteSlug]/memorabilia.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[athleteSlug]/memorabilia"])
      });
    }
  